<template>
    <div>
        <br/>
        <br/>
        <board :items="items" :lanes="lanes" :hasUsers="false" :autoAdd="true" v-on:item-updated="handleItemUpdated" v-on:item-clicked="handleItemClicked" v-on:item-created="handleItemCreated">
            <template scope="props">
                <div class="kb-card-header">
                <p class="kb-card-title" style = "font-weight:bold;font-size:larger;color:#fcac18;">{{ props.data.summary }}</p>
                </div>
                <p class="kb-card-description" >{{ props.data.descripcion }}</p>
                <p class="kb-card-description" style="text-align: end;font-weight:bold;">{{ props.data.user }}</p>
            </template>
        </board>
        <modal name="hello-world" >
            <h2 style="font-weight:bold;color:#fcac18;padding-left:2rem;padding-bottom: 2rem;">Complete the order</h2>
            <div class="form-group">
                <div class="row" style="display: flex;justify-content: center;">
                    <label class="col-sm-2 control-label">Order</label>
                    <div class="col-sm-6">
                        <input
                            type="text"
                            placeholder="Orden"
                            id="orden"
                            class="form-control"
                            v-model="orden"
                        />
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row" style="display: flex;justify-content: center;">
                    <label class="col-sm-2 control-label">Mesero</label>
                    <div class="col-sm-6">
                        <input
                            type="text"
                            placeholder="Mesero"
                            id="mesero"
                            class="form-control"
                            v-model="mesero"
                        />
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row" style="display: flex;justify-content: center;">
                    <label class="col-sm-2 control-label">Descripción</label>
                    <div class="col-sm-6">
                        <textarea
                            type="textarea"
                            placeholder="Descripcion"
                            id="descripcion"
                            class="form-control"
                            v-model="descripcion"
                            rows="3"
                        />
                    </div>
                </div>
            </div>
            <div class="form-group">
                      <div class="row">
                        <div style= "justify-content: space-evenly;display: flex;">
                          <button
                            class="btn btn-primary btn-flat"
                            v-on:click="createOrder"
                          >
                            Crear Orden
                          </button>
                          <button
                            class="btn btn-primary btn-flat"
                            v-on:click="hide"
                          >
                            Cerrar
                          </button>
                        </div>
                      </div>
                    </div>
        </modal>
    </div>
    
</template>

<script>
import Board from '@salamander.be/vue-kanban-board'
import '@salamander.be/vue-kanban-board/dist/vue-kanban-board.css'
import firebase from "firebase";
import "./../assets/css/kanban-modal.css";

export default {
	name: 'app',
	components: {
		Board
	},
	data() {
		return {
            tables:[],
			lanes: [{ name: 'Ordenado', slug: 0 }, { name: 'En Cocina', slug: 1 }, { name: 'Listo', slug: 2 }, { name: 'Entregado', slug: 3 } ],
            items: [],
            orden: "",
            status: 0,
            mesero: "",
            descripcion: "",
		}
    },
    methods: {
		handleItemUpdated(itemId, status, index) {
            console.log(itemId);
            var db = firebase.firestore()
            db.collection("restaurants").doc("1001").collection("ordenes").doc(itemId).update({
                status: parseInt(status),
            }).then((doc) => {
                // ON SUCCESS
                console.log(doc)
            
            }).catch((err) => {
                // CATCH FAILURE
                console.log(err)
            })
		},
		handleItemClicked(item) {
            // Clicked code
		},
		handleItemCreated(item) {
            console.log("CREATED")
            this.orden = item.summary;
            this.status = item.status;
            this.$modal.show('hello-world');
        },
        getData(){
            var db = firebase.firestore()
            let temp=[]
            db.collection('restaurants/1001/ordenes').get().then((subCollectionSnapshot) => {
                subCollectionSnapshot.forEach((subDoc) => {
                    console.log(subDoc.data());
                    var a = subDoc.data();
                    a.id = subDoc.id;

                    temp.push(a);
                });
            
                this.items=temp
                console.log(this.items)
            })
        },
        hide: function() {
            this.orden = "";
            this.status = 0;
            this.descripcion = "";
            this.mesero = "";
            this.$modal.hide('hello-world');
            window.location.reload();
        },
        createOrder: function() {
            var db = firebase.firestore()
            db.collection("restaurants").doc("1001").collection("ordenes").add({
                status: this.status,
                summary: this.orden,
                user: this.mesero,
                descripcion: this.descripcion
            }).then((doc) => {
                // ON SUCCESS
                console.log(doc)
                this.getData();
                window.location.reload();
            
            }).catch((err) => {
                // CATCH FAILURE
                console.log(err)
            })
            this.orden = "";
            this.status = 0;
            this.descripcion = "";
            this.mesero = "";
        }
    },
    mounted(){
        this.getData()
    }
}
</script>
